module.exports = __webpack_public_path__ + "img/antenna-01.e41fe0fc.svg";